var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mb-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imagem.src,"alt":_vm.imagem.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }